/* istanbul ignore file */
import {
  makeStyles, shorthands, tokens,
} from '@fluentui/react-components';

export const useSiteNavigationItemAccordionStyles = makeStyles({
  button: {
    ...shorthands.border('none'),
    backgroundColor: tokens.colorSubtleBackground,
    fontWeight: tokens.fontWeightRegular,
    width: '-webkit-fill-available',
    justifyContent: 'start',
    ...shorthands.padding('5px', '10px'),
  },
});

export const usePopOverContainerStyles = makeStyles({
  popOverContainer: {
    maxHeight: '90vh',
    ...shorthands.padding('12px'),
    overflowY: 'auto',
    OverflowX: 'hidden',
    '&::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      width: tokens.spacingHorizontalS,
    },
    '&::-webkit-scrollbar-track': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralBackground3,
    },
    '&::-webkit-scrollbar-thumb': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralForeground3,
    },
    '& ::-webkit-scrollbar-thumb:hover': {
      backgroundColor: tokens.colorNeutralForeground3Hover,
    },
  },
});

export const useSiteNavigationItemPopoverStyles = makeStyles({
  menu: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.gap('0px'),
  },
  menuButton: {
    alignSelf: 'stretch',
    ...shorthands.padding('6px', '10px', '6px', '10px'),
  },
  popOverTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.padding('1px', '0px', '1px', '12px'),
  },
  popOverTitle: {
    fontWeight: 600,
    fontSize: '14',
    lineHeight: '20px',
  },
  popOverPinButton: {},
  accordionButton: {
    ...shorthands.border('none'),
    backgroundColor: tokens.colorSubtleBackground,
    fontWeight: tokens.fontWeightRegular,
    width: '-webkit-fill-available',
    justifyContent: 'start',
    ...shorthands.padding('5px', '10px'),
  },
});
